<template>
    <rooom-guide-form-section @submitted="editTour">
        <template #form>

            <!-- Name -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="name" value="Name" />
                <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" autocomplete="name" />
            </div>
            
            <!-- Station hinzufügen -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="email" value="Station hinzufügen (Location)" />
                <select @change="addStation" class="mt-1 block w-full" 
                v-model="form_add_station.location_id">
                    <option value="null"></option>
                    <option v-bind:value="location.id" v-for="location in locations">
                        Location ID:{{ location.id }} Latitude:{{ location.latitude }} Longitude:{{ location.longitude }}
                    </option>
                </select>
            </div>

            <!-- Stationen -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="stations" value="Stationen" />
                <ul>
                    <li v-for="station in this.tour.stations" class="inline-flex rounded-full bg-indigo-500 text-white px-4 drop-shadow-lg mr-1 mb-1">
                        Location ID:{{ station.location_id }}
                    </li>
                </ul>
            </div>

        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Gespeichert.
            </jet-action-message>

            <jet-action-message :on="form_add_station.recentlySuccessful" class="mr-3">
                Gespeichert.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Speichern
            </jet-button>
        </template>
    </rooom-guide-form-section>
</template>

<script>
import JetButton from '@/Jetstream/Button.vue'
import RooomGuideFormSection from '@/RooomGuide/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

export default {
    components: {
        JetActionMessage,
        JetButton,
        RooomGuideFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
    },

    props: ['tour', 'locations'],

    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',

                // input field v-model attribute
                name: this.tour.name,
                id: this.tour.id,
                description: this.tour.description,
            }),

            form_add_station: this.$inertia.form({
                _method: 'POST',

                tour_id: this.tour.id,
                location_id: null
            }),
        }
    },

    methods: {
        editTour() {
            this.form.put(route('tour.update', this.form.id), {
                errorBag: 'createNewTour',
                preserveScroll: true,
            });
        },
        addStation(e) {
            if(e.target.value == 'null'){
                return;
            }
            this.form_add_station.post(route('tour.addStation'), {
                preserveScroll: true
            })
        }
    },
}
</script>
